import {
  CustomerGroupType,
  minimalCustomerGroupSchema,
} from "@redotech/redo-model/customers/customer-group-definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCustomerGroupsMinimal = {
  name: "getCustomerGroupsMinimal" as const,
  input: z.object({ type: createEnum(CustomerGroupType).optional() }),
  output: z.array(minimalCustomerGroupSchema),
};
